import React from "react"
import { getCitiesByStateId, getBarangaysByCityId } from "../../utils"
import SelectField from "../SelectField"

class BarangayField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      barangays: []
    }
  }

  getBarangays = cityName => {
    const cities = getCitiesByStateId()
    const city = cities.find(city => city.name.toLowerCase() === cityName)
    const barangays =
      (city &&
        getBarangaysByCityId(city.id) &&
        getBarangaysByCityId(city.id).map(barangay => ({
          value: barangay.name.toLowerCase(),
          label: barangay.name
        }))) ||
      []
    return barangays
  }

  componentDidMount() {
    if (this.props.cityname) {
      this.setState(
        state => ({
          ...state,
          barangays: this.getBarangays(this.props.cityname)
        }),
        async () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          const barangay =
            (this.props.value &&
              this.props.value.value &&
              this.state.barangays.find(
                b =>
                  b.value.toLowerCase() === this.props.value.value.toLowerCase()
              )) ||
            ""
          if (this.props.value && this.props.value.value && barangay) {
            if (
              this.props.value.label !== barangay.label &&
              this.props.value.label.toLowerCase() ===
                barangay.label.toLowerCase()
            ) {
              this.props.value.label = barangay.label
            } else setFieldValue(name, barangay || "")
          }
          await Promise.resolve()
        }
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.cityname !== prevProps.cityname) {
      this.setState(
        state => ({
          ...state,
          barangays: this.getBarangays(this.props.cityname)
        }),
        async () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          const barangay =
            (this.props.value &&
              this.props.value.value &&
              this.state.barangays.find(
                b =>
                  b.value.toLowerCase() === this.props.value.value.toLowerCase()
              )) ||
            ""
          setFieldValue(name, barangay || "")
          await Promise.resolve()
        }
      )
    }
  }

  render() {
    return (
      <span className="BarangayField">
        <SelectField
          {...this.props}
          options={
            (this.state.barangays.length > 0 && this.state.barangays) || [
              {
                value: "none",
                label: ""
              }
            ]
          }
          defaultValue={{ value: "none", label: "" }}
          isDisabled={this.props.disabled || this.state.barangays.length <= 0}
        />
      </span>
    )
  }
}

export default BarangayField
